import { useState } from 'react'
import Button from '@/shared/Buttons/Button'
import Image from '@/shared/Common/Image'
import SidePage from '@/shared/SidePage'
import CloseIcon from '@/assets/icons/close.svg?react'
import AssetManager from './AssetManager'
import { ICmsAsset } from '../cms.types'
import { getAbsoluteAssetUrl } from '../cms.utils'
import css from '../cms.module.css'

interface IProps {
  name: string
  value: string
  assets: ICmsAsset[]
  loading: boolean
  error?: boolean
  inscription?: string
  onChange: (value: string, name: string) => void
  onRefresh: () => Promise<void>
}

const AssetPicker = (props: IProps) => {
  const [open, setOpen] = useState(false)
  const asset = props.assets.find((item) => item.url === props.value)

  return (
    <>
      <div>
        <div className={css.assetPicker} data-error={props.error}>
          <div className={css.imagePreview}>
            {props.value ? (
              <Image
                alt={asset?.fileName || props.value}
                src={getAbsoluteAssetUrl(props.value)}
                style={{ width: '100%', height: '100%' }}
              />
            ) : null}
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <p className="text-nm line-clamp">{asset?.fileName || props.value || 'Файл не выбран'}</p>
            {props.inscription && <p className="text-sm text-error">{props.inscription}</p>}
          </div>
          {props.value && (
            <Button size="default" type="default" icon={<CloseIcon />} onClick={() => props.onChange('', props.name)} />
          )}
          <Button size="default" type="default" text="Выбрать" onClick={() => setOpen(true)} />
        </div>
      </div>
      <SidePage open={open} onClose={() => setOpen(false)} size="large">
        <div className={css.sidePageContent}>
          <AssetManager
            assets={props.assets}
            loading={props.loading}
            selectedUrl={props.value}
            selectMode
            onSelect={(nextAsset) => {
              props.onChange(nextAsset.url, props.name)
              setOpen(false)
            }}
            onRefresh={props.onRefresh}
          />
        </div>
      </SidePage>
    </>
  )
}

export default AssetPicker
